/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Child_Set_TeenInputs */

const fr_guardian_child_set_teen = /** @type {(inputs: Guardian_Child_Set_TeenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marquer comme ado`)
};

/**

* @param {Guardian_Child_Set_TeenInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_child_set_teen = /** @type {((inputs?: Guardian_Child_Set_TeenInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Child_Set_TeenInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_child_set_teen(inputs)
});